<template>
    <div class="row">
        <!-- Sorry Message -->
        <div class="col-12">
            <h2>{{ $t("message.sorry") }}</h2>
            <p>{{ $t("message.noProdSubHeader") }}</p>
        </div>

        <section class="col-12">
            <no-products-form :fromPath="fromPath" :query="query" />
        </section>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import noProductsForm from '@/components/NoProductsForm.vue';
import { RudderstackChatMixin } from '@/rudderstack/track/mixins/chat';

export default {
	// Pass query string in as properties
	props: {
		query: {
			type: Object,
			required: true
		}
	},

	mixins: [RudderstackChatMixin],

	components: {
		noProductsForm
	},

	data() {
		return {
			fromPath: ''
		};
	},

	computed: {
		...mapState('search', ['dealership_id'])
	},

	created() {
		this.$rudderstack.page(this.$route.meta.category, this.$route.meta.name, {
			...this.$route.query,
			'dealership_id': this.dealership_id
		});
	},

	// Path of the page that sent the consumer to no-products
	beforeRouteEnter(to, from, next) {
		next((vm) => {
			vm.fromPath = from.path;
		});
	}
};
</script>
